/* Wholesale notes page engine - renders /cart?view=wholesale straight from the Google Sheet.
   Two tabs: Notes (the working selection) and Orders (submitted order requests with status and
   expandable detail, fetched lazily from listSubmissions on first open). Cache-first: the notes
   pane paints immediately from the sessionStorage context, then refreshes in the background and
   only re-renders if the data actually changed AND the person has not started editing. Each
   line's image and style name link back to the product page (with the variant selected) so a
   buyer can jump back to swap colors without hunting the line sheet. After an order submit the
   context is force-refreshed: committed lines leave the working view (they now live in the order
   snapshot), notes-only lines stay, and the buttons come back live. On submit the current
   wholesale unit price of every sized line rides along ({ note_id: cents }) so the backend can
   freeze prices into the snapshot for the order document and, later, the QuickBooks invoice.
   Loads the client's notes through window.WSApi (getContext), pulls each style's live variant
   image and price from /products/{handle}.js, and draws a line per note with a themed size-run
   picker, a per-line delivery window picker, and (for staff) a per-line note field. Variant-less
   lines (staff Misc. colors) price from the style's first variant so order totals stay honest.
   Edits write onto the note's row via updateNote (debounced). Windows are stored as the label
   string so the sheet and PDF stay human-readable. \"Save my notes\" is soft; \"Submit order
   request\" requires a run and a window on every non-notes-only line plus a ship-to address
   (default preselected, inline add-address form via addAddress). */
(function () {
  var root = document.querySelector('[data-ws-cart]');
  if (!root) return;
  var api = window.WSApi;
  var IS_STAFF = !!(window.WS_CONFIG && window.WS_CONFIG.customer && window.WS_CONFIG.customer.staff);

  var MIN = parseInt(root.getAttribute('data-min-pairs'), 10) || 8;
  var CURRENCY = root.getAttribute('data-ws-currency') || 'USD';
  var BROWSE_URL = root.getAttribute('data-browse-url') || '/collections/wholesale-ss27';
  var SIZES = ['36','36.5','37','37.5','38','38.5','39','39.5','40','40.5','41','42'];

  var money = (function () {
    try { var f = new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }); return function (c) { return f.format((c || 0) / 100); }; }
    catch (e) { return function (c) { return '$' + ((c || 0) / 100).toFixed(2); }; }
  })();

  var packs = [];
  try { packs = JSON.parse(document.querySelector('[data-ws-packs]').textContent) || []; } catch (e) {}
  packs.forEach(function (p) {
    if (typeof p.sizes === 'string') { try { p.sizes = JSON.parse(p.sizes) || {}; } catch (e) { p.sizes = {}; } }
    if (!p.sizes || typeof p.sizes !== 'object') p.sizes = {};
    if (typeof p.whole === 'string') p.whole = (p.whole === 'true');
    if (typeof p.total === 'string') p.total = parseInt(p.total, 10) || 0;
  });
  packs.sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
  var byCode = {}; packs.forEach(function (p) { byCode[p.code] = p; });
  var basePacks = packs.filter(function (p) { return p.type === 'base'; });
  var addonPacks = packs.filter(function (p) { return p.type === 'add_on'; });

  var wholeSet = {};
  try { (JSON.parse(document.querySelector('[data-ws-wholemap]').textContent) || []).forEach(function (h) { wholeSet[h] = true; }); } catch (e) {}

  var stateEl = root.querySelector('[data-ws-state]');
  var linesEl = root.querySelector('[data-ws-lines]');
  var footEl = root.querySelector('[data-ws-foot]');
  var summaryEl = root.querySelector('[data-ws-summary]');
  var fulfillEl = root.querySelector('[data-ws-fulfill]');
  var submitNotesBtn = root.querySelector('[data-ws-submit-notes]');
  var submitOrderBtn = root.querySelector('[data-ws-submit-order]');
  var msgEl = root.querySelector('[data-ws-msg]');
  var notesPane = root.querySelector('[data-ws-notes-pane]');
  var ordersPane = root.querySelector('[data-ws-orders-pane]');
  var ordersState = root.querySelector('[data-ws-orders-state]');
  var ordersEl = root.querySelector('[data-ws-orders]');

  var clientId = null;
  var lines = [];
  var productCache = {};
  var windows = [];
  var addresses = [];
  var selShipId = '';
  var dirty = false;
  var bootSeq = 0;
  var ordersLoaded = false;

  var openPop = null;
  document.addEventListener('click', function () { if (openPop) { openPop.hidden = true; openPop = null; } });
  function togglePop(pop) {
    var wasOpen = !pop.hidden;
    if (openPop && openPop !== pop) openPop.hidden = true;
    if (wasOpen) { pop.hidden = true; openPop = null; } else { pop.hidden = false; openPop = pop; }
  }
  function chevron() { return '<svg class="ws-run__chev" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4"></path></svg>'; }
  function openGuide() { var t = document.querySelector('.ws-guide-link[data-ws-guide-open]'); if (t) t.click(); }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function packPairs(p) { if (!p) return 0; if (p.total) return p.total; var s = 0, k; for (k in (p.sizes || {})) s += p.sizes[k] || 0; return s; }
  function sumSizes(o) { var s = 0, k; for (k in (o || {})) s += parseInt(o[k] || 0, 10) || 0; return s; }
  function runSizes(st) {
    var out = {}, k;
    if (st.base && byCode[st.base]) { var b = byCode[st.base]; for (k in (b.sizes || {})) out[k] = (out[k] || 0) + b.sizes[k]; }
    (st.addons || []).forEach(function (c) { var a = byCode[c]; if (a) { for (k in (a.sizes || {})) out[k] = (out[k] || 0) + a.sizes[k]; } });
    return out;
  }
  function effective(st) { return st.custom ? st.custom : (st.base ? runSizes(st) : {}); }
  function statePairs(st) { if (st.notesOnly) return 0; return sumSizes(effective(st)); }
  function runLabel(st) {
    if (st.notesOnly) return 'Notes only';
    if (st.custom) return 'Custom run';
    if (st.base && byCode[st.base]) return byCode[st.base].name;
    return '';
  }

  function initState(note) {
    var st = { base: null, addons: [], custom: null, notesOnly: false, window: String(note.window || '') };
    var run = String(note.run || '');
    var sizes = note.sizes;
    if (typeof sizes === 'string' && sizes) { try { sizes = JSON.parse(sizes); } catch (e) { sizes = {}; } }
    if (!sizes || typeof sizes !== 'object') sizes = {};
    if (run === 'Notes only') { st.notesOnly = true; return st; }
    if (sumSizes(sizes) > 0) {
      var match = basePacks.filter(function (p) { return sameSizes(p.sizes, sizes); })[0];
      if (match) { st.base = match.code; } else { st.custom = sizes; }
    }
    return st;
  }
  function sameSizes(a, b) {
    var ak = Object.keys(a || {}), bk = Object.keys(b || {}).filter(function (k) { return (b[k] || 0) > 0; });
    if (ak.length !== bk.length) return false;
    for (var i = 0; i < ak.length; i++) { if ((a[ak[i]] || 0) !== (b[ak[i]] || 0)) return false; }
    return true;
  }

  function statusHTML(st) {
    if (st.notesOnly) return '<span class="ws-status--note">Saved as a note, no size run yet</span>';
    var p = statePairs(st);
    if (!p) return '<span class="ws-status--todo">No size run chosen yet</span>';
    if (p < MIN) return '<span class="ws-status--warn">' + p + ' pairs. Under the ' + MIN + '-pair minimum, this color likely will not be accepted.</span>';
    return '<span class="ws-status--ok">' + p + ' pairs</span>';
  }

  var saveTimers = {};
  function save(line) {
    dirty = true;
    var st = line.state;
    clearTimeout(saveTimers[line.note.note_id]);
    saveTimers[line.note.note_id] = setTimeout(function () {
      api.call('updateNote', api.identity({
        client_id: clientId || '',
        note_id: line.note.note_id,
        run: runLabel(st),
        window: st.window || '',
        sizes: st.notesOnly ? {} : effective(st),
        pairs: statePairs(st)
      }));
    }, 500);
  }

  var noteTimers = {};
  function saveLineNote(line, val) {
    dirty = true;
    clearTimeout(noteTimers[line.note.note_id]);
    noteTimers[line.note.note_id] = setTimeout(function () {
      api.call('updateNote', api.identity({ client_id: clientId || '', note_id: line.note.note_id, note: val }));
    }, 600);
  }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function escT(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }

  function makeDropdown(placeholder, options, onSelect) {
    var dd = el('div', 'ws-run');
    var trigger = el('button', 'ws-run__trigger'); trigger.type = 'button';
    var trigLabel = el('span', 'ws-run__label', escT(placeholder));
    trigger.appendChild(trigLabel);
    trigger.insertAdjacentHTML('beforeend', chevron());
    var pop = el('div', 'ws-run__pop'); pop.hidden = true;
    options.forEach(function (o) {
      var b = el('button', 'ws-run__opt'); b.type = 'button'; b.setAttribute('data-value', o.value);
      b.innerHTML = '<span class="ws-run__check" aria-hidden="true"></span><span>' + escT(o.label) + '</span>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        pop.hidden = true; openPop = null;
        onSelect(o.value, o.label);
      });
      pop.appendChild(b);
    });
    trigger.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); togglePop(pop); });
    dd.appendChild(trigger); dd.appendChild(pop);
    return {
      wrap: dd,
      set: function (value, label) {
        trigLabel.textContent = label || placeholder;
        pop.querySelectorAll('.ws-run__opt').forEach(function (b) { b.classList.toggle('is-selected', b.getAttribute('data-value') === String(value)); });
      }
    };
  }

  function addrLabel(a) {
    var bits = [];
    if (a.street1) bits.push(a.street1);
    if (a.city) bits.push(a.city);
    if (a.region) bits.push(a.region);
    var s = bits.join(', ');
    return (a.label && String(a.label).toLowerCase() !== 'ship-to') ? (a.label + ' - ' + s) : s;
  }

  /* ---------------- Orders tab ---------------- */

  function statusLabel(s) {
    s = String(s || '').toLowerCase();
    if (!s || s === 'submitted') return 'Pending approval';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function fmtDate(iso) {
    try { return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); }
    catch (e) { return String(iso).slice(0, 10); }
  }

  function buildOrderCard(s) {
    var card = el('div', 'ws-order');
    var head = el('div', 'ws-order__head');
    head.appendChild(el('span', 'ws-order__id', 'Order request ' + escT(s.submission_id)));
    head.appendChild(el('span', 'ws-order__date', escT(fmtDate(s.created))));
    head.appendChild(el('span', 'ws-order__status', escT(statusLabel(s.status))));
    card.appendChild(head);
    var colors = (s.lines || []).length;
    card.appendChild(el('div', 'ws-order__sub', colors + ' color' + (colors === 1 ? '' : 's') + ' &middot; ' + (s.pairs || 0) + ' pairs'));
    var toggle = el('button', 'ws-order__toggle'); toggle.type = 'button'; toggle.textContent = 'View detail';
    card.appendChild(toggle);
    var detail = el('div', 'ws-order__detail'); detail.hidden = true;
    var rows = (s.lines || []).map(function (n) {
      return '<tr><td>' + escT(n.style) + '</td><td>' + escT(n.color) + '</td><td>' + escT(n.run) + '</td><td>' + escT(n.window) + '</td><td>' + escT(n.pairs) + '</td></tr>';
    }).join('');
    detail.innerHTML = '<table class="ws-order__table"><tr><th>Style</th><th>Color</th><th>Run</th><th>Window</th><th>Pairs</th></tr>' + rows + '</table>';
    var meta = '';
    if (s.ship_to) {
      meta += 'Ship to: ' + escT([s.ship_to.street1, s.ship_to.city, s.ship_to.region].filter(Boolean).join(', '));
    }
    if (s.order_note) meta += (meta ? ' &middot; ' : '') + 'Note: ' + escT(s.order_note);
    if (meta) detail.appendChild(el('div', 'ws-order__meta', meta));
    card.appendChild(detail);
    toggle.addEventListener('click', function () {
      detail.hidden = !detail.hidden;
      toggle.textContent = detail.hidden ? 'View detail' : 'Hide detail';
    });
    return card;
  }

  function loadOrders() {
    ordersLoaded = true;
    ordersState.hidden = false;
    ordersState.textContent = 'Loading your orders...';
    ordersEl.hidden = true;
    api.call('listSubmissions', api.identity({ client_id: clientId || '' })).then(function (resp) {
      var subs = resp && resp.ok && resp.data ? (resp.data.submissions || null) : null;
      if (!subs) { ordersState.textContent = 'Could not load your orders. Please reload.'; return; }
      if (!subs.length) { ordersState.textContent = 'No order requests yet.'; return; }
      ordersState.hidden = true;
      ordersEl.hidden = false;
      ordersEl.innerHTML = '';
      subs.forEach(function (s) { ordersEl.appendChild(buildOrderCard(s)); });
    }).catch(function () { ordersState.textContent = 'Could not load your orders. Please reload.'; });
  }

  root.querySelectorAll('[data-ws-tab]').forEach(function (t) {
    t.addEventListener('click', function () {
      root.querySelectorAll('[data-ws-tab]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      var name = t.getAttribute('data-ws-tab');
      if (notesPane) notesPane.hidden = name !== 'notes';
      if (ordersPane) ordersPane.hidden = name !== 'orders';
      if (name === 'orders' && !ordersLoaded) loadOrders();
    });
  });

  /* ---------------- Notes pane ---------------- */

  function renderFulfill() {
    if (!fulfillEl) return;
    fulfillEl.innerHTML = '';

    var sLab = el('label', 'v-stack gap-1');
    sLab.appendChild(el('span', 'smallcaps text-xs text-subdued', 'Ship to'));
    var opts = addresses.map(function (a) { return { value: a.address_id, label: addrLabel(a) }; });
    opts.push({ value: 'ADD', label: '+ Add a new address' });
    var sDD = makeDropdown('Choose a ship-to address', opts, function (v, label) {
      if (v === 'ADD') { addrForm.hidden = false; s1.focus(); return; }
      dirty = true;
      selShipId = v; sDD.set(v, label); addrForm.hidden = true;
    });
    sLab.appendChild(sDD.wrap);
    fulfillEl.appendChild(sLab);

    var addrForm = el('div', 'ws-addr-form'); addrForm.hidden = true;
    function inp(ph, cls) { var i = el('input', cls || null); i.type = 'text'; i.placeholder = ph; i.autocomplete = 'off'; addrForm.appendChild(i); return i; }
    var s1 = inp('Street', 'span2');
    var s2 = inp('Street 2 (optional)', 'span2');
    var ci = inp('City');
    var rg = inp('State / region');
    var po = inp('Postal code');
    var co = inp('Country');
    var saveBtn = el('button', 'button ws-submit--notes ws-addr-save'); saveBtn.type = 'button'; saveBtn.textContent = 'Save address';
    addrForm.appendChild(saveBtn);
    var addrErr = el('div', 'ws-addr-err');
    addrForm.appendChild(addrErr);
    fulfillEl.appendChild(addrForm);

    saveBtn.addEventListener('click', function () {
      if (!s1.value.trim() || !ci.value.trim()) { addrErr.textContent = 'Street and city are required.'; return; }
      saveBtn.disabled = true; addrErr.textContent = '';
      dirty = true;
      api.call('addAddress', api.identity({
        client_id: clientId || '',
        label: 'ship-to',
        street1: s1.value.trim(),
        street2: s2.value.trim(),
        city: ci.value.trim(),
        region: rg.value.trim(),
        postal: po.value.trim(),
        country: co.value.trim(),
        is_default: addresses.length ? 'false' : 'true'
      })).then(function (resp) {
        saveBtn.disabled = false;
        var a = resp && resp.ok && resp.data ? resp.data.address : null;
        if (a && (a.address_id || resp.data.address_id)) {
          a.address_id = a.address_id || resp.data.address_id;
          addresses.push(a);
          selShipId = String(a.address_id);
          renderFulfill();
          msg('', '');
        } else {
          addrErr.textContent = (resp && resp.error) ? resp.error : 'Could not save the address.';
        }
      }).catch(function () { saveBtn.disabled = false; addrErr.textContent = 'Could not save the address.'; });
    });

    if (selShipId) {
      var a2 = addresses.filter(function (x) { return String(x.address_id) === String(selShipId); })[0];
      if (a2) sDD.set(selShipId, addrLabel(a2));
    }
  }

  function buildLine(note, product) {
    var variant = product ? (product.variants || []).filter(function (v) { return String(v.id) === String(note.variant_id); })[0] : null;
    var priceV = variant || (product && product.variants && product.variants.length ? product.variants[0] : null);
    var unitCents = priceV ? priceV.price : 0;
    var srpCents = priceV ? (priceV.compare_at_price || 0) : 0;
    var img = variant && variant.featured_image ? variant.featured_image.src : (product && product.featured_image ? product.featured_image : '');
    var whole = !!wholeSet[note.handle];
    var st = initState(note);
    var pdpUrl = note.handle ? ('/products/' + encodeURIComponent(note.handle) + (note.variant_id ? '?variant=' + encodeURIComponent(note.variant_id) : '')) : '';

    var li = el('li', 'ws-line');
    var head = el('div', 'ws-line__head');
    if (img) {
      var im = el('img', 'ws-line__thumb'); im.src = img.split('?')[0] + '?width=200'; im.alt = note.style || '';
      if (pdpUrl) { var imA = el('a', 'ws-line__imglink'); imA.href = pdpUrl; imA.appendChild(im); head.appendChild(imA); }
      else head.appendChild(im);
    }
    else { head.appendChild(el('span', 'ws-line__chip')); }
    var info = el('div', 'v-stack gap-0.5');
    if (pdpUrl) {
      var titleA = el('a', 'ws-line__title', escT(note.style || (product ? product.title : '')));
      titleA.href = pdpUrl;
      info.appendChild(titleA);
    } else {
      info.appendChild(el('span', 'ws-line__title', escT(note.style || (product ? product.title : ''))));
    }
    info.appendChild(el('span', 'ws-line__color smallcaps text-xs text-subdued', escT(note.color || (variant ? variant.title : ''))));
    var unitTxt = 'WS ' + money(unitCents) + (srpCents > unitCents ? (' &middot; SRP ' + money(srpCents)) : '') + ' / pr';
    info.appendChild(el('span', 'ws-line__unit smallcaps text-xs text-subdued', unitTxt));
    head.appendChild(info);
    var rm = el('button', 'ws-line__remove'); rm.type = 'button'; rm.textContent = 'Remove';
    head.appendChild(rm);
    li.appendChild(head);

    var controls = el('div', 'ws-line__controls v-stack gap-3');

    var runHead = el('div', 'ws-run-head h-stack justify-between gap-2');
    runHead.appendChild(el('span', 'smallcaps text-xs text-subdued', 'Size run'));
    var guideLink = el('button', 'ws-guide-inline link text-xs'); guideLink.type = 'button'; guideLink.textContent = 'View size runs';
    guideLink.addEventListener('click', function (e) { e.preventDefault(); openGuide(); });
    runHead.appendChild(guideLink);
    controls.appendChild(runHead);

    var options = [{ value: '', label: 'Choose a size run' }, { value: 'NOTES', label: 'Notes only (no run yet)' }];
    basePacks.forEach(function (p) { if (!whole || p.whole) options.push({ value: p.code, label: p.name + '  (' + packPairs(p) + ' pr)' }); });
    options.push({ value: 'CUSTOM', label: 'Build your own' });

    var dd = el('div', 'ws-run');
    var trigger = el('button', 'ws-run__trigger'); trigger.type = 'button';
    var trigLabel = el('span', 'ws-run__label', 'Choose a size run');
    trigger.appendChild(trigLabel);
    trigger.insertAdjacentHTML('beforeend', chevron());
    var pop = el('div', 'ws-run__pop'); pop.hidden = true;
    options.forEach(function (o) {
      var b = el('button', 'ws-run__opt'); b.type = 'button'; b.setAttribute('data-value', o.value);
      b.innerHTML = '<span class="ws-run__check" aria-hidden="true"></span><span>' + o.label + '</span>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); selectRun(o.value); pop.hidden = true; openPop = null; });
      pop.appendChild(b);
    });
    trigger.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); togglePop(pop); });
    dd.appendChild(trigger); dd.appendChild(pop);
    controls.appendChild(dd);

    var addonsWrap = el('div', 'ws-addons');
    addonsWrap.appendChild(el('span', 'smallcaps text-xs text-subdued', 'Reinforce (optional)'));
    var addonOpts = el('div', 'ws-addons__opts'); addonsWrap.appendChild(addonOpts);
    addonPacks.forEach(function (p) {
      if (whole && Object.keys(p.sizes).some(function (k) { return k.indexOf('.5') >= 0; })) return;
      var lab = el('label', 'ws-addon');
      var cb = el('input'); cb.type = 'checkbox'; cb.value = p.code; lab.appendChild(cb);
      lab.appendChild(el('span', null, p.name + ' (+' + packPairs(p) + ')'));
      cb.addEventListener('change', function () {
        st.addons = st.addons || [];
        if (cb.checked) { if (st.addons.indexOf(p.code) < 0) st.addons.push(p.code); }
        else { st.addons = st.addons.filter(function (c) { return c !== p.code; }); }
        line.render(); save(line); renderSummary();
      });
      addonOpts.appendChild(lab);
    });
    controls.appendChild(addonsWrap);

    var customWrap = el('div', 'ws-custom');
    var customLabel = el('span', 'smallcaps text-xs text-subdued', 'Sizes in this run. Edit any number to customize.');
    customWrap.appendChild(customLabel);
    var grid = el('div', 'ws-grid'); customWrap.appendChild(grid);
    var gridSizes = whole ? SIZES.filter(function (s) { return s.indexOf('.5') < 0; }) : SIZES;
    gridSizes.forEach(function (sz) {
      var cell = el('label', 'ws-cell');
      cell.appendChild(el('span', 'ws-cell__sz', sz));
      var inp = el('input'); inp.type = 'number'; inp.min = '0'; inp.inputMode = 'numeric'; inp.className = 'ws-cell__in'; inp.setAttribute('data-sz', sz);
      cell.appendChild(inp);
      inp.addEventListener('input', function () {
        if (st.base && !st.custom) { st.custom = runSizes(st); st.base = null; st.addons = []; }
        st.custom = st.custom || {};
        var n = parseInt(inp.value || 0, 10) || 0;
        if (n > 0) st.custom[sz] = n; else delete st.custom[sz];
        line.render(); save(line); renderSummary();
      });
      grid.appendChild(cell);
    });
    controls.appendChild(customWrap);

    var winWrap = el('div', 'ws-line__window v-stack gap-1');
    winWrap.appendChild(el('span', 'smallcaps text-xs text-subdued', 'Delivery window'));
    var winDD = makeDropdown('Choose a delivery window', windows.map(function (w) {
      return { value: w.label, label: w.label };
    }), function (v) {
      st.window = v; line.render(); save(line); renderSummary();
    });
    winWrap.appendChild(winDD.wrap);
    controls.appendChild(winWrap);

    var statusEl = el('div', 'ws-line__status'); controls.appendChild(statusEl);
    var totalEl = el('div', 'ws-line__total'); controls.appendChild(totalEl);

    if (IS_STAFF) {
      var noteInput = el('input', 'ws-line__note'); noteInput.type = 'text';
      noteInput.placeholder = 'Note for this color (optional)'; noteInput.value = note.note || '';
      noteInput.addEventListener('input', function () { saveLineNote(line, noteInput.value); });
      controls.appendChild(noteInput);
    }

    li.appendChild(controls);

    function selectRun(v) {
      if (v === 'NOTES') { st.notesOnly = true; st.base = null; st.custom = null; st.addons = []; }
      else if (v === 'CUSTOM') { st.notesOnly = false; st.base = null; if (!st.custom) st.custom = {}; }
      else if (v === '') { st.notesOnly = false; st.base = null; st.custom = null; st.addons = []; }
      else { st.notesOnly = false; st.base = v; st.custom = null; }
      line.render(); save(line); renderSummary();
    }

    rm.addEventListener('click', function () {
      rm.disabled = true;
      dirty = true;
      var vid = note.variant_id;
      var done = (vid && window.WSNotes && window.WSNotes.remove) ? window.WSNotes.remove(vid) : api.call('removeNote', api.identity({ client_id: clientId, note_id: note.note_id }));
      Promise.resolve(done).then(function () {
        lines = lines.filter(function (l) { return l !== line; });
        if (li.parentNode) li.parentNode.removeChild(li);
        renderSummary();
        if (!lines.length) showEmpty();
      });
    });

    var line = { note: note, variant: variant, unitCents: unitCents, state: st, li: li };
    line.render = function () {
      var s = line.state;
      var chosen = s.notesOnly ? 'NOTES' : (s.custom ? 'CUSTOM' : (s.base || ''));
      trigLabel.textContent = runLabel(s) || 'Choose a size run';
      pop.querySelectorAll('.ws-run__opt').forEach(function (b) { b.classList.toggle('is-selected', b.getAttribute('data-value') === chosen); });
      var showGrid = !s.notesOnly && (!!s.custom || !!s.base);
      customWrap.hidden = !showGrid;
      customLabel.textContent = s.custom ? ('Custom run (' + MIN + ' pairs minimum)') : 'Sizes in this run. Edit any number to customize.';
      addonsWrap.hidden = s.notesOnly || !!s.custom || !s.base;
      addonOpts.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = (s.addons || []).indexOf(cb.value) >= 0; });
      var eff = effective(s);
      grid.querySelectorAll('input[data-sz]').forEach(function (inp) {
        var sz = inp.getAttribute('data-sz');
        var val = (eff && eff[sz]) ? eff[sz] : '';
        if (document.activeElement !== inp) inp.value = val;
      });
      winWrap.hidden = s.notesOnly;
      winDD.set(s.window, s.window || null);
      statusEl.innerHTML = statusHTML(s);
      var lp = statePairs(s);
      totalEl.textContent = lp > 0 ? ('WS line total: ' + money(unitCents * lp)) : '';
    };

    lines.push(line);
    linesEl.appendChild(li);
    line.render();
  }

  function renderSummary() {
    var colors = lines.length, pairs = 0, incomplete = 0, under = 0, notesCount = 0, needWindow = 0, orderTotal = 0;
    lines.forEach(function (l) {
      var s = l.state;
      if (s.notesOnly) { notesCount++; return; }
      var p = statePairs(s);
      if (!p) { incomplete++; return; }
      pairs += p; if (p < MIN) under++;
      if (!s.window) needWindow++;
      orderTotal += (l.unitCents || 0) * p;
    });
    var html = '<div class="ws-summary__row"><span>' + colors + ' color' + (colors === 1 ? '' : 's') + '</span><span>' + pairs + ' pairs total</span></div>';
    html += '<div class="ws-summary__row ws-summary__total"><span>Wholesale order total</span><span>' + money(orderTotal) + '</span></div>';
    if (incomplete) html += '<div class="ws-summary__note ws-status--todo">' + incomplete + ' color' + (incomplete > 1 ? 's' : '') + ' still need a size run.</div>';
    if (needWindow) html += '<div class="ws-summary__note ws-status--todo">' + needWindow + ' color' + (needWindow > 1 ? 's' : '') + ' still need a delivery window.</div>';
    if (notesCount) html += '<div class="ws-summary__note ws-status--note">' + notesCount + ' color' + (notesCount > 1 ? 's' : '') + ' saved as notes (no run yet).</div>';
    if (under) html += '<div class="ws-summary__note ws-status--warn">' + under + ' color' + (under > 1 ? 's' : '') + ' under the ' + MIN + '-pair minimum may not be accepted.</div>';
    summaryEl.innerHTML = html;
    if (submitNotesBtn) submitNotesBtn.disabled = colors === 0;
    if (submitOrderBtn) submitOrderBtn.disabled = incomplete > 0 || needWindow > 0 || colors === 0;
  }

  function showEmpty(html) {
    linesEl.hidden = true; footEl.hidden = true;
    stateEl.innerHTML = html || ('Your selection is empty. <a href="' + BROWSE_URL + '" class="link">Browse the collection</a>.');
    stateEl.hidden = false;
  }

  function msg(t, k) { msgEl.textContent = t; msgEl.className = 'ws-submit__msg' + (k ? ' ws-status--' + k : ''); }

  function doSubmit(type) {
    var noteEl = root.querySelector('[data-ws-note]');
    var note = noteEl ? noteEl.value : '';
    if (type === 'order') {
      if (!selShipId) { msg('Choose a ship-to address (or add one) before submitting an order request.', 'warn'); if (fulfillEl) fulfillEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var anyUnder = lines.some(function (l) { return !l.state.notesOnly && statePairs(l.state) > 0 && statePairs(l.state) < MIN; });
      if (anyUnder && !window.confirm('Some colors are under the ' + MIN + '-pair minimum and may not be accepted. Submit anyway?')) return;
    }
    // Freeze the current wholesale unit price of every sized line into the
    // submission, so the order document and invoice price from this moment.
    var prices = {};
    lines.forEach(function (l) {
      if (!l.state.notesOnly && statePairs(l.state) > 0) prices[l.note.note_id] = l.unitCents || 0;
    });
    if (submitNotesBtn) submitNotesBtn.disabled = true;
    if (submitOrderBtn) submitOrderBtn.disabled = true;
    msg('Submitting...', '');
    api.call('submit', api.identity({
      client_id: clientId || '',
      type: type,
      order_note: note,
      prices: prices,
      ship_to: type === 'order' ? selShipId : ''
    })).then(function (resp) {
      if (resp && resp.ok) {
        if (type === 'order') {
          msg('Order request submitted. We will follow up to confirm.', 'ok');
          ordersLoaded = false;
          dirty = false;
          if (api.refresh) {
            api.refresh().then(function (fresh) {
              if (!fresh) return;
              cachedSig = ctxSig(fresh);
              boot(fresh).then(function () {
                if (!lines.length) {
                  showEmpty('Your order request has been submitted. We will follow up to confirm. <a href="' + BROWSE_URL + '" class="link">Continue browsing the collection</a>.');
                }
              });
            });
          }
        } else {
          msg('Your notes are saved. You can come back to them any time.', 'ok');
          renderSummary();
        }
      } else { renderSummary(); msg((resp && resp.error) ? resp.error : 'Something went wrong. Please try again.', 'warn'); }
    }).catch(function () { renderSummary(); msg('Something went wrong submitting. Please try again.', 'warn'); });
  }

  if (submitNotesBtn) submitNotesBtn.addEventListener('click', function () { doSubmit('notes'); });
  if (submitOrderBtn) submitOrderBtn.addEventListener('click', function () { doSubmit('order'); });

  if (!api) { stateEl.textContent = 'Could not load your selection. Please reload.'; return; }

  function ctxSig(ctx) {
    try { return JSON.stringify({ n: ctx.notes, a: ctx.addresses, w: ctx.windows, c: ctx.client_id }); }
    catch (e) { return 'x' + Math.random(); }
  }

  function boot(ctx) {
    var my = ++bootSeq;
    clientId = ctx.client_id;
    windows = ctx.windows || [];
    addresses = ctx.addresses || [];
    if (!selShipId) {
      var def = addresses.filter(function (a) { return String(a.is_default).toLowerCase() === 'yes'; })[0] || addresses[0];
      if (def) selShipId = String(def.address_id);
    }
    var notes = ctx.notes || [];
    lines = [];
    linesEl.innerHTML = '';
    if (!notes.length) { showEmpty(); return Promise.resolve(); }
    return Promise.all(notes.map(function (n) { return fetchProduct(n.handle); })).then(function (products) {
      if (my !== bootSeq) return;
      stateEl.hidden = true; linesEl.hidden = false; footEl.hidden = false;
      notes.forEach(function (n, i) { buildLine(n, products[i]); });
      renderFulfill();
      renderSummary();
    });
  }

  var cached = api.cached ? api.cached() : null;
  var cachedSig = null;
  if (cached && cached.client_id) { cachedSig = ctxSig(cached); boot(cached); }

  api.context().then(function (fresh) {
    if (!fresh) { if (!cachedSig) stateEl.textContent = 'Could not load your selection. Please reload.'; return; }
    if (!cachedSig) { boot(fresh); return; }
    if (dirty) return;
    if (ctxSig(fresh) !== cachedSig) boot(fresh);
  }).catch(function () { if (!cachedSig) stateEl.textContent = 'Could not load your selection. Please reload.'; });
})();
